.content {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 4px;
}

.file {
  display: flex;
  min-width: 0;
  height: 28px;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px;
  border-radius: 2px;
  background-color: var(--x-color-background);
  font-size: 14px;
  transition: background-color 0.2s;

  .name,
  .content {
    color: var(--x-color-text-primary);
    font-size: 12px;
  }

  .content {
    flex: 1;
  }

  &:hover {
    background-color: #e6e9eb;
  }

  .actions {
    display: flex;
    margin-right: -4px;
    margin-left: 4px;
  }
}

.date {
  margin-left: 5px;
  color: var(--x-color-text-secondary);
  font-size: 11px;
}
